import { initializeIcons } from '@uifabric/icons';

const loadIcon = () => {
    initializeIcons("https://res.cdn.office.net/files/fabric-cdn-prod_20240129.001/assets/icons/");
};

export default loadIcon;